import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/ham_and_cheese_croissant.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function HNC() {
  useMetaTracking("ViewContent", {
    content_name: "Ham & Cheese Croissant",
    content_category: "Regular Menu",
    content_ids: ["ham_cheese_croissant"],
    content_type: "pastries",
    value: 4.00,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Ham & Cheese Croissant | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="Buttery croissant dough filled with ham & melted cheese, baked until golden and crisp. A perfect harmony of rich, creamy, and flaky textures in every bite."
        />
        <meta property="og:title" content="Ham & Cheese Croissant | Đông Hưng Viên Bakery" />
        <meta
          property="og:description"
          content="Buttery croissant dough filled with ham & melted cheese, baked until golden and crisp. A perfect harmony of rich, creamy, and flaky textures in every bite."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>
      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f", color: "#fff" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Ham & Cheese Croissant"
          titleSubHead="$4.00 each"
          detailBody="Buttery croissant dough filled with ham & melted cheese, baked until golden and crisp. A perfect harmony of rich, creamy, and flaky textures in every bite."
          detailBodyBr="Contains: wheat, dairy, egg"
          ProductCardBtn="View Full Regular Menu"
          btnLink="/regular-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default HNC;